import { useMount } from 'ahooks';
import { Languages, useLanguageStore } from './hooks';
import { HomePage } from './pages/HomePage';
import { ConfigProvider } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import useUrlState from '@ahooksjs/use-url-state';

const App = () => {
  useMount(() => {
    if (window.innerWidth < 980) {
      window.location.href = 'https://carbonai-mobile.carbonstop.com';
    }
  });
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#0CBF9F',
          borderRadius: 8,
        },
      }}
    >
      <div className="w-full h-full">
        {/* <HomePage /> */}
        <RouterProvider router={router} />
      </div>
    </ConfigProvider>
  );
};

export default App;
